import { useId } from "react";

/** Returns stable unique ids for SVG defs (clipPath, mask, etc.). */
export function useSvgIds(...names) {
  const base = useId().replace(/:/g, "");
  return Object.fromEntries(names.map((name) => [name, `${base}-${name}`]));
}
